import { useContext, useEffect } from 'react';
import { Context } from '@components/Context';
import useNavigate from '@utils/useNavigate';
import { useRedirectUrl } from './useRedirectUrl';

export default function useRedirectUnauthorisedUsers(noUnauthorisedRedirect?: boolean) {
  const { state } = useContext(Context);
  const { navigateWrapper } = useNavigate();
  const { getPathWithRedirectUrl } = useRedirectUrl();

  useEffect(() => {
    if (state?.firebaseLoaded && !noUnauthorisedRedirect) {
      if (!state.firebaseAuth?.currentUser || state.firebaseAuth?.currentUser?.isAnonymous) {
        navigateWrapper(getPathWithRedirectUrl('/dashboard/login/'), { replace: true });
      }
    }
  }, [state?.firebaseLoaded, state?.firebaseAuth?.currentUser, noUnauthorisedRedirect]);
}
